import { ProducteContext } from 'context/3cat/ProducteProvider';
import { useContext } from 'react';

export const useProducte = () => {
    const { urlAppPrefix, isWebviewActive, isTv } = useContext(ProducteContext) || {};

    return { urlAppPrefix, isWebviewActive, isTv };
};
